<template>
  <div :class="'sample-ribbon__' + size" class="sample-ribbon">
    <div class="circle" />
    <div class="text">Sample<br>Project</div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SampleRibbon',

  props: {
    /* small, medium, or large */
    size: {
      type: String,
      default: 'large',
    },
  },
})
</script>

<style lang="scss">
.sample-ribbon {
  opacity: 0.8;
  display: block !important;
  position: absolute;
  z-index: 1;

  &__small {
    transform: scale(0.7);
  }
  &__medium {
    transform: scale(0.8);
  }
  &__large {
    transform: scale(1);
  }
  &__obnoxious {
    transform: scale(4);
  }

  .text {
    cursor: default;
    position: absolute;
    padding: 2px 4px;
    background-color: var(--color-background-header);
    color: $color--pink-60;
    text-transform: uppercase;
    font-size: 11px;
    line-height: 11px;
    font-weight: $bold;
    transform: rotate(-14deg);
    border-radius: 2px;
    border: solid 2px $color--pink-80;
    text-align: center;
    width: 70px;
  }

  .circle {
    position: absolute;
    height: 50px;
    width: 50px;
    top: -10px;
    left: 10px;
    border: double;
    border-color: $color--pink-80;
    border-radius: 50%;
    display: inline-block;
  }
}
</style>
